module.exports = __webpack_public_path__ + "static/media/ai.2a693765.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/ai.png
// module id = 2543
// module chunks = 0